import clickOutside from './clickOutside'
import debounce from './debounce'

const directivesMap: { [key: string]: any } = {
  clickOutside,
  debounce
}

const directives = {
  install: (app: any) => {
    Object.keys(directivesMap).forEach((key) => {
      // 注册自定义指令
      app.directive(key, directivesMap[key])
    })
  }
}

export default directives
